import { useLayoutEffect, useRef } from 'react';

import { useBaseCheckboxRadio } from '../VBaseCheckboxRadio';
import { useBaseCheckboxRadioGroup } from '../VBaseCheckboxRadioGroup/hook';
import {
  CheckBox,
  CheckBoxIndeterminate,
  CheckBoxOutlineBlank,
} from '../asset';
import style from './style';
import type { VInnerCheckboxProps } from './type';

const VInnerCheckbox = (props: VInnerCheckboxProps) => {
  const { checked, onCheckedChange, id, disabled } = useBaseCheckboxRadio();
  const group = useBaseCheckboxRadioGroup<true>();
  const hiddenInputRef = useRef<HTMLInputElement>(null);

  const isStandAlone = !group;
  const isChecked = isStandAlone
    ? checked === true
    : group.value?.includes(props.value as string);
  const isIndeterminate = checked === 'indeterminate';
  const Icon = isIndeterminate
    ? CheckBoxIndeterminate
    : isChecked
      ? CheckBox
      : CheckBoxOutlineBlank;

  const handleCheckedChange = () => {
    if (isStandAlone) {
      onCheckedChange?.(isIndeterminate ? true : !checked);
    } else {
      isChecked
        ? group.onValueChange?.(
            group.value?.filter(v => v !== props.value) as string[],
          )
        : group.onValueChange?.([
            ...(group.value ?? []),
            props.value as string,
          ]);
    }
  };

  useLayoutEffect(() => {
    if (hiddenInputRef.current) {
      hiddenInputRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const _style = style(props);

  return (
    <>
      <input
        ref={hiddenInputRef}
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={handleCheckedChange}
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none',
          width: 0,
          height: 0,
        }}
        tabIndex={-1}
        aria-hidden="true"
        disabled={disabled}
      />
      <Icon
        className={_style.icon}
        role="checkbox"
        aria-checked={isChecked}
        onClick={handleCheckedChange}
      />
    </>
  );
};

export default VInnerCheckbox;
